import { createSelector } from 'reselect'

const getState = state => state.Providers

const getProviders = state => getState(state).providers

const getConnectProviderRequest = state =>
  getState(state).connectProviderRequest

const getRemoveProviderRequest = state => getState(state).removeProviderRequest

const getProvidersMap = createSelector(
  [getProviders],
  providers => (!providers ? {} : providers.entities.providers)
)

const getProvidersIds = createSelector(
  [getProviders],
  providers => (!providers ? [] : providers.result)
)

const getProvidersList = createSelector(
  [getProvidersMap, getProvidersIds],
  (providersMap, providersIds) => providersIds.map(id => providersMap[id])
)

const getFlatProviders = createSelector([getProvidersList], providers =>
  providers.map(provider => provider.provider)
)

export {
  getProvidersList,
  getFlatProviders,
  getConnectProviderRequest,
  getRemoveProviderRequest
}
